import { withInstall } from '@xzx-design/utils'
import _Calendar from './src/calendar'

export const Calendar = withInstall(_Calendar)
export default Calendar

export * from './src/calendar'
export * from './src/types'
